export function ucFirstFilter(input: string): string {

    if(input === null || input.length === 0){
        return null;
    }

    return input.charAt(0).toUpperCase() + input.slice(1);
}